// extracted by mini-css-extract-plugin
export default {"backWrapper":"SecondaryLayout_backWrapper__9LES+","bodyWrapper":"SecondaryLayout_bodyWrapper__POFFY"};